// credit: https://www.30secondsofcode.org/js/s/bifurcate-by

const bifurcateBy = (arr, fn) =>
  arr.reduce(
    (acc, val, i) => (acc[fn(val, i) ? 0 : 1].push(val), acc),
    [[], []]
  );

export default bifurcateBy;
